import { render, staticRenderFns } from "./book.vue?vue&type=template&id=382da187"
import script from "./book.vue?vue&type=script&lang=ts"
export * from "./book.vue?vue&type=script&lang=ts"
import style0 from "./book.vue?vue&type=style&index=0&id=382da187&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavbarSmall: require('/vercel/path0/components/navbar-small.vue').default,LoadingSpinner: require('/vercel/path0/components/loading-spinner.vue').default,ChefBookPersonalInformation: require('/vercel/path0/components/chef/book/personal-information.vue').default,UiButton: require('/vercel/path0/components/ui/button.vue').default,UiError: require('/vercel/path0/components/ui/error.vue').default,ChefBookFilter: require('/vercel/path0/components/chef/book/filter.vue').default,ChefBookExperienceAddress: require('/vercel/path0/components/chef/book/experience-address.vue').default,ChefExtraCard: require('/vercel/path0/components/chef/extra-card.vue').default,UiTextarea: require('/vercel/path0/components/ui/textarea.vue').default,ChefPricingList: require('/vercel/path0/components/chef/pricing-list.vue').default,ChefBookVatInvoice: require('/vercel/path0/components/chef/book/vat-invoice.vue').default,ChefBookFaq: require('/vercel/path0/components/chef/book/faq.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
